module.exports = __webpack_public_path__ + "img/verification.3ec9a81c.png";